export default {
  BeforeDraw: 0,
  Drawing: 1,
  AfterDraw: 2
}
